import '../Scss/Legacy/Styles.scss';
import '../Scss/Legacy/apmButton.scss';
import '../Scss/Legacy/apmTeaser2.scss';
import '../Scss/Legacy/faqs.scss';
import '@jb/component/Atom';
import '@jb/component/Molecule';

// Add email spam protection script
document.body.innerHTML = document.body.innerHTML.replace(/-please-remove/g, '');
